import { IdExterno } from '../../models/usuario.model';

const getCookie = (valor: string) => {
  const cookieValor = document.cookie.split('; ').find((cookie) => cookie.startsWith(`${valor}=`));
  return cookieValor ? JSON.parse(decodeURIComponent(cookieValor.split('=')[1])) : null;
};

const getParams = (searchParams: URLSearchParams) => {
  const getCookies = getCookie('userInfo');
  const possuiContaParam = searchParams.get('exists');

  let possuiConta = null;
  if (possuiContaParam === 'true') possuiConta = true;
  else if (possuiContaParam === 'false') possuiConta = false;

  return {
    loginHint: searchParams.get('login_hint') ?? localStorage.getItem('login_hint') ?? (getCookies?.email as string),
    nome: searchParams.get('name'),
    atila: searchParams.get('idExterno.atila') ?? (getCookies?.inscricao_atila as string),
    origem: searchParams.get('origem') ?? (getCookies?.origem as string),
    enturmacao: searchParams.get('enturmacao') ?? (getCookies?.enturmacao as string | null),
    possuiConta,
  };
};

export const handleSearchParams = () => {
  const searchParams = new URLSearchParams(document.location.search);
  const { loginHint, nome, atila, origem, enturmacao, possuiConta } = getParams(searchParams);

  const isAtilaEmpty = !atila;
  const isLead = origem?.toLowerCase() === 'portal' || isAtilaEmpty;

  const idExterno: IdExterno = {
    atila: isLead ? null : atila,
  };

  return { loginHint, nome, idExterno, isLead, enturmacao, origem, possuiConta };
};
